import React, { useState, useEffect } from 'react';
import { defaultHeight, devicesWidths } from './constants';
import Wrapper from './css';
const ImageVideoWrapper = ({ children, className, isDesktop, params, }) => {
    const [minWidth, setMinWidth] = useState(devicesWidths.mobile.min);
    const [height, setHeight] = useState(defaultHeight);
    const { aspectRatio, childWidth, columnsInRow } = params;
    useEffect(() => {
        if (isDesktop) {
            setMinWidth(devicesWidths.desktop.min);
        }
    }, [isDesktop]);
    useEffect(() => {
        if (!childWidth) {
            const mWidth = minWidth / (columnsInRow || 1);
            setHeight(Math.round(mWidth / (aspectRatio || mWidth)));
        }
    }, [childWidth, columnsInRow, aspectRatio, minWidth]);
    return (React.createElement(Wrapper, { minHeight: height, className: className }, children));
};
export default ImageVideoWrapper;
